// ============================================================
// CENTRAL PROJECT CONFIGURATION — 杀零牛 (Sha Ling Niu / SLN)
// Edit this ONE file to update every occurrence across the site.
// ============================================================

export const projectConfig = {
  name: "Sha Ling Niu",
  chineseName: "杀零牛",
  symbol: "SLN",

  // --- Blockchain ---
  contractAddress: "0x61C9096bB839aC2587bcc2c2772d0bAA95dBFffF",
  chainId: 56,
  network: "BNB Smart Chain",
  tokenStandard: "BEP-20",
  explorerUrl: "https://bscscan.com",

  // --- Trading / socials ---
  // Leave empty ("") to hide the corresponding button/link automatically.
  // Never invent URLs — paste the official ones here when announced.
  tradingUrl: "https://four.meme/token/0x61C9096bB839aC2587bcc2c2772d0bAA95dBFffF",
  fourMemeUrl: "https://four.meme/token/0x61C9096bB839aC2587bcc2c2772d0bAA95dBFffF",
  twitterUrl: "https://x.com/SLN1M1",
  telegramUrl: "https://t.me/SLN1M1",

  // --- Documents ---
  whitepaperUrl: "/SLN_Whitepaper_v1.0.pdf",

  // --- Domain (used for SEO references) ---
  domain: "https://sln.life",

  // --- Taxes (percent of each transaction) ---
  buyTax: 5,
  sellTax: 5,
  // Distribution OF the collected tax (not an initial allocation)
  taxDistribution: {
    fundsRecipient: 20,
    burn: 20,
    holders: 30,
    liquidity: 30,
  },
};

// True when a URL from config is actually configured (non-empty http(s) link)
export const isUrlSet = (url) =>
  typeof url === "string" && /^https?:\/\/.+/.test(url) && !url.includes("[") && !url.includes("INSERT");

export const explorerTokenUrl = `${projectConfig.explorerUrl}/token/${projectConfig.contractAddress}`;
export const explorerAddressUrl = `${projectConfig.explorerUrl}/address/${projectConfig.contractAddress}`;

// Effective share of EACH transaction (tax% * distribution share)
export const effectiveShare = (sharePct) => ((projectConfig.buyTax * sharePct) / 100).toFixed(1);

// Public BSC RPC endpoints for read-only on-chain data (no API key needed)
export const BSC_RPC_ENDPOINTS = [
  "https://bsc-dataseed.binance.org",
  "https://bsc-dataseed1.defibit.io",
  "https://bsc-dataseed.bnbchain.org",
];

// BUY button target: official trading URL if configured, otherwise guide users to How to Buy
export const buyTarget = isUrlSet(projectConfig.tradingUrl)
  ? { href: projectConfig.tradingUrl, external: true }
  : { href: "#how-to-buy", external: false };
